export enum ProductTagType {
    Protein,
    Vegan,
    GlutenFree,
    Spicy,
    SugarFree,
    // LowCarb,
    // Kids
}

export function getProductTagTypeFromString(tag: string): ProductTagType | null {
    switch (tag.toLowerCase()) {
        case "protein":
            return ProductTagType.Protein;
        case "vegan":
            return ProductTagType.Vegan;
        case "glutenfree":
        case "gluten-free":
            return ProductTagType.GlutenFree;
        case "spicy":
            return ProductTagType.Spicy;
        case "sugarfree":
        case "sugar-free":
            return ProductTagType.SugarFree;
        // case "lowcarb":
        // case "low-carb":
        //     return ProductTagType.LowCarb;
        // case "kids":
        //     return ProductTagType.Kids;
        default:
            return null;
    }
}   

export function getStringFromProductTagType(tagType: ProductTagType): string {
    switch (tagType) {
        case ProductTagType.Protein:
            return "Protein";
        case ProductTagType.Vegan:
            return "Vegan";
        case ProductTagType.GlutenFree:
            return "Gluten free";
        case ProductTagType.Spicy:
            return "Spicy";
        case ProductTagType.SugarFree:
            return "Sugar free";
        // case ProductTagType.LowCarb:
        //     return "Low carb";
        // case ProductTagType.Kids:
        //     return "Kids";
        default:
            return "";
    }
}